module.exports = {
  language: {
    name: 'EN',
    current: 'Current Language',
  },
  common: {
    save: 'Save',
    sure: 'Confirm',
    tip: 'Tips',
    submit: 'Submit',
    option: 'Operation',
    edit: 'Edit',
    cancel: 'Delete',
    send: 'Send',
    viewMore: 'More',
    rules: {
      phone: 'The mobile phone number cannot be empty',
      newPassword: 'New Password can not be empty',
      confirmPassword: 'Confirm New Password can not be empty',
      email: 'The mailbox cannot be empty',
    },
    require: 'Please complete the compulsory information !',
    phone: 'Mobile Number：',
    email: 'E-mail：',
    collected: {
      exhibition: 'exhibitors',  //收藏展商
      exhibits: 'exhibits',  //收藏展品
      live: 'live',
      activity: 'activity',
    },
    recommend: {
      exhibition: 'Exhibitors Highlight',
      exhibits: 'Exhibits Highlight',
      live: 'Live Broadcast - Highlight',
      activity: 'Activities Highlight',
    },
    tips: {
      exhibition: 'Recommended Exhibitors Recommended Activities',
      exhibits: 'Recommended Activities',
      live: 'No live broadcast Information',
      activity: 'No Activity Information',
      message: 'No Related Information',
    },
    viewAll: 'More',
    myMessage: 'MY Messages',
    consult: 'Talk',
    meetingRoom: 'Activity location',
    qrCode: 'Scan the QR code to watch the Live Broadcast',
    changeContent: 'New Batch',
    search: 'Search',
    boothNum: 'Booth No.：',
    more: 'More',
    collect: 'collect',
    clearCollect: 'Cancel',
    view: 'View',
  },
  login: {
    title: 'New China International Exhibition Center (NCIEC), Beijing, China | 25-28 October 2023',
    goback: 'Home',
    en: 'English',
    zh: 'CH',
    welcome: 'Welcome',
    content: 'Visitor Center',
    placeholder1: 'Mobile',
    placeholder2: 'Password',
    agree: 'I have read and agree to',
    privacyStatement: 'the Privacy Statement',
    forgetPassword: 'Forget Password?',
    loginNow: 'Login',
    clickTip: "Don't have an account yet ? Click",
    register: '“Visitor Registration”',
    registerInfo: ',to Complete Your Registration',
    visitRegistration: 'Visitor Registration',
    validatorInfo: 'Inconsistent New Password. Please input again.',
    reset: {
      title: 'Reset  Password',
      label1: 'Register mobile number：',
      placeholder1: 'Please input Mobile Number',
      label2: 'Verification Code',
      placeholder2: 'Please Enter Verification Code',
      sendCode: 'Send Verification Code',
      label3: 'New Password：',
      placeholder3: 'Please Enter New Password',
      label4: 'Confirm New Password：',
      placeholder4: 'Please Confirm New Password ',
    },
    rules: {
      code: 'The verification code cannot be empty',
      password: 'The password cannot be empty',
    },
    messages: {
      code: 'Verification code has been sent',
      success: 'New Password Reset Completed!',
      fail: 'Password change failed!！',
      loginError1: 'Login failed, please tick the terms and conditions.',
      loginError2: 'Login failed, account or password error',
      loginSuccess: 'Congratulations!  Login Successful!',
    },
  },
  home: {
    editInfo: 'Edit',
    company: 'Company：',
    address: 'Address：',
    statistics: 'Statistics',
  },
  teamInvite: {
    teamTitle: 'Group Invitation',
    tishi1:
      'In order to e provide a safe environment for the participants, the organizer will strictly implement the relevant provisions of the "Requirements for the Joint Prevention and Control Mechanism of the State Council" and the "Guidelines for the Prevention and Control of COVID-19 for the Beijing Convention and Exhibition Industry".',
    tishi2:
      'For all exhibitors/visitors, preregistration with real-name authentication" process will be adopted, and participants need to present their original ID / Passport to enter the venue.',
    placeholder1: 'Please enter Name / Company Name',
    search: 'Search',
    addbuys: 'New Added Buyer',
    departement: 'Department / Position',
    companyName: 'Company',
    companyAddress: 'Company Address',
    editbuy: 'Edit Buyer Information',
    inforTishi: 'Request Failed.',
    inforTishi2: 'Please submit again.',
    inforTishi3: 'Information Submitted Successfully',
    inforTishi4: 'The information has been submitted successfully',
    idcart: 'ID',
    certificate: 'Military ID',
    passport: 'Passport ',
    hk: 'Hong Kong and Macau Home Return Permit',
  },
  person: {
    title: {
      info1: 'personal details',
      info2: '',
      info3: '',
      info4: 'An asterisk (*) is mandatory',
    },
    tabs: {
      tab1: 'Basic Information',
      tab2: 'Confirmation Letter',
      tab3: 'Questionnaire',
      tab4: 'Group Registration',
      tab5: 'Reset Password',
    },
    baseInfos: {
      companyName: 'Company Name:',
      address: 'Company Address:',
      name: 'Name：',
      named: 'Salutation:',
      named1: 'Mr',
      named2: 'Mrs / Miss',
      type: 'Type of ID：',
      number: 'ID Number：',
      phone: 'Mobile Number:',
      email: 'E-mail：',
      dept: 'Department:',
      duty: 'Job Title：',
      tips: {
        emailTip: 'Visitor Pre-registration Confirmation Letter will be sent to this email address. ',
      },
      rules: {
        number: 'ID no- field cannot be blank',
      },
    },
    letter: {
      company: 'Company：',
      phone: 'Mobile Number：',
      registAccount: 'Login Name：',
      password: 'Password：',
      time: 'Time：',
      address: 'Venue：',
      position: 'Visitor  Entrance：',
      img: 'Hallmap：',
      companyName: 'China Coal Consultant International',
      telephone: 'Phone：',
      contacts: 'Contact Person：',
      tips: {
        tip1: '*',
        tip2: 'Please note',
        tip3: 'Confirmation  has been sent to your mailbox, if you did not received the email, please check  email trash box.',
        tip4: 'To modify your registration information, click here to log in for modification ',
      },
      infos: {
        info1: 'Your Visitor Registration Information',
        info2: 'Your Login Information',
        info3: 'General Information ',
        info4: 'Enquiries ',
      },
      informations: {
        title: 'Dear',
        tip1: 'Thank you for registering to visit the China Coal and Mining Expo 2023.',
        tip2:
          'You have successfully completed your pre-registration. The exhibition will be held on October 25-28, 2023 at New China International Exhibition Center(NCIEC) Beijing, China.',
        tip3: 'Please save this confirmation and  bring your original ID card / passport to visit the CCM 2023.',
        time1: 'October 25-28, 9:00-17:00',
        time2: '',
        address: 'New China International Exhibition Center(NCIEC) Beijing, China',
        position: 'NCIEC East, South, West, North Registration Halls',
        linkPerson: 'Wang Zichen',
        phone: '010-84293614',
        email: 'chinaminexpo@vip.163.com',
      },
    },
    quest: {
      other: 'Others, please specify',
      placeholder: 'Please Enter',
    },
    group: {
      button1: 'Add New Member',
      button2: 'Edit Member',
      button3: 'Add Member',
      tip1: 'If you have more member to visit, ',
      downloadText: 'please click here to download the template',
      uploadText: 'Upload Document',
      tip2: 'Please check the information of the person to be submitted before submission',
      downloadFileName: '团队注册模板.xlsx',
      noSubmit: 'uncommitted ',
      submited: 'submitted',
      tableLabel: {
        name: 'Name',
        type: 'ID Type',
        number: 'ID Number',
        unitName: 'Company Name ',
        unitAddress: 'Company Address',
        duty: 'Job title',
        phone: 'Mobile Number',
        email: 'E-mail',
        status: 'Condition',
        phoneNumber: 'Mobile number',
      },
      placeholders: {
        name: 'Please Enter Name ',
        unitName: 'Please Enter Company Name',
        unitAddress: 'Please Enter Company Address',
        type: 'Please Enter Type of ID',
        number: 'Please Enter  ID Number',
        phoneNumber: 'Please enter mobile number',
        email: 'Please enter email ',
        duty: 'Please Enter  Job Title',
      },
      rules: {
        require: {
          name: 'The name cannot be empty',
          unitName: 'The unit name cannot be empty',
          type: 'The ID Document Type cannot be empty',
          number: 'The id number cannot be b',
        },
        errors: {
          type: 'Please select ID Document Type',
          type1: 'ID Number is not valid, please input again',
          phone: 'The mobile phone number format is invalid. Please enter it again',
          email: 'Invalid email address, please input again. ',
          authFail: 'Invalid ID No. Please input again ! ',
        },
      },
      options: {
        label1: 'National ID',
        label2: 'Military Officer ID',
        label3: 'Passport',
        label4: 'Hong Kong and Macau Pass',
      },
      messages: {
        excel: 'Successfully Uploaded the Member Information in excel list. !',
        submit: 'Member Information has been submitted successfully. !',
        edit: 'Edit Member Information Successfully. !',
        cancelSuccess: 'Delete Member Information Successfully. !',
        addSuccess: 'Add New Member Successfully!',
        addFail: 'Fail to add New Member!',
        limit: {
          tip1: '当前限制选择 3 个文件，本次选择了',
          tip2: '个文件，共选择了',
          tip3: '个文件',
        },
        confirm: {
          tip1: 'Confirm to remove',
          tip2: '?',
        },
        cancel: {
          text: 'Confirm to delete? ',
          title: 'Attention!',
          confirmText: 'Confirm',
          cancelText: 'Cancel',
        },
      },
    },
    password: {
      passwordRule: 'Password should not be less than 6 charactes/ digits',
      confirmRule: 'Inconsistent New Password. Please input again.',
    },
  },
  recommend: {
    exhibition: 'Exhibitors Highlight',
    exhibits: 'Exhibits Highlight',
    live: 'Live Broadcast Highlight',
    activity: 'Activities Highlight',
  },
  sidebar: {
    projectName: 'Visitor Center',
    home: 'Home',
    baseInfo: 'Personal Information',
    recommend: 'Highlights',
    collected: 'My Favorite',
    message: 'My Message',
    error: 'Logout failed',
    xianshang: 'Online Exhibition',
  },
  search: {
    placeholderType: 'Please Select Product Type',
    placeholderName: "Please Enter Exhibitor's Name ",
    placeholderProName: 'Please Enter Exhibits Name',
    nodata: 'No recommendation',
    nocCollect:"No collection"
  },
  collected: {
    exhibition: 'exhibitors',  //收藏展商
    exhibits: 'exhibits',  //收藏展品
    live: 'live',
    activity: 'activity',
    consult: 'Talk',
  },
  messages: {
    info: 'Exhibitor Information',
    company: 'Sender',
    time: 'Send Time',
  },
  tinymce: {
    placeholder: 'Please Enter',
  },
  header: {
    title: 'Organizing Committee of China Coal & Mining Expo 2023',
    time: 'New China International Exhibition Center (NCIEC), Beijing, China 25-28 October 2023',
  },
  logout: {
    cancellation: 'Delete Visitor Account',
    tip: 'Tip',
    sureTip: 'Are you sure you want to log out?',
    sure: 'Confirm',
    cancel: 'Cancel',
  },
  privacy: {
    title: 'Privacy Statement',
    statement:
      'This website is committed to protecting your privacy. You do not need to provide any personal information to access most pages of our site. However, sometimes we do need certain information to provide you with the services you request, and this Privacy Statement explains the collection and use of data in these situations. This Privacy Statement applies only to this website. ',
    tip1: {
      title: 'Collect Your Personal Information',
      info1:
        'We may need information that identifies you (personal information about the user) or information that can contact you. In general, we ask you to provide this information when you purchase or register for the products of this website. The personal information collected on this website is generally limited to basic information such as user name, contact number, contact address, QQ number, etc., however, additional information may also need to be collected when providing the services you request.',
      info2:
        'This website also collects certain information about your computer software and hardware. This information may include your IP address, browser type, operating system, domain name, access time, and related web site address. This information is used to run the Services, to guarantee the quality of services and to provide general statistics on the use of this website.',
      info3:
        'This website also collects information about which pages customers visit on this website. These site access data are identified only by a unique ID number and will never be linked to personal information unless the user agrees, as detailed below. ',
    },
    tip2: {
      title: 'Use of Your Personal Information',
      info1: 'Your Personal Information is Used for Several Purposes:',
      info2: '1. To ensure that our website meets your requirements.',
      info3: '2. The transmission of your request or purchase of services, such as products.',
      info4: '3. Help to create and provide content that match your request',
      info5:
        '4. Send reminder to you for product upgrade information, special offers, update information and other new services from this website (if you request these services)',
      info6: '5. Allow you to access to our full website content and those pages with certain access restrictions.',
      info7:
        '6. By agreeing to this Privacy Statement, you are deemed to be permitting us to send promotional information related to our products to your communications tool.',
      info8:
        'For research purposes, we will combine site access data and anonymous statistics, which we may then use to provide content to match your request . In certain restricted access sections of this website,we will combine your personal information and site access data in order to provide you with personalized content with your consent. If you refuse to do so, we will not provide you with personalized services or combine your personal information and site access data.',
      info9:
        'We occasionally hire other companies to provide restricted services on our behalf, including packing, mailing and sending purchased items,  providing  customer services, mailing letters, and processing  registrations etc. We only provide those companies with the information they need for these services and prohibit the use of that information for other purposes.',
      info10:
        'This website discloses your personal information as required by law, or has good reason to believe that it is necessary to: (a) meet the express provisions of the law or comply with the legal procedures applicable to this website or this site;;(b) protect the rights or property of this website and its series of web sites, and (c) protect the personal safety of employees of this website, users of the products or services of this website or the general public in an emergency.',
    },
    tip3: {
      title: 'Control your personal information',
      info1:
        'When you provide us with personal information through registration or other means, this website does not share that information with third parties without permission, except as previously listed. This information is for the purposes mentioned earlier only.',
      info2:
        'This website may periodically send text messages or make phone calls informing you of technical services or security issues related to the products or services you request, or confirming your request for products or services. You cannot choose to withdraw these services because they are an essential part of the services you select.',
    },
    tip4: {
      title: 'The security of your personal information',
      info1:
        'This website strictly protects the security of your personal information. We use a variety of security technologies and procedures to protect your personal information from unauthorized access, use or disclosure. For example, we store personal information you provide on computer servers located in controlled locations, and access to those servers is restricted. When transmitting sensitive information, such as credit card numbers, over the Internet, we protect information by using encryption, such as the Secure Socket Layer (SSL) protocol. ',
    },
    tip5: {
      title: 'The Use of the Cookie',
      info1:
        'When someone visits a site, a cookie is left on his computer (if the customer agrees to accept the cookie) and reads the cookie if the customer has visited the site before. One of the purposes of cookies is to help collect the site visit statistics described above.',
      info2:
        'We also use cookies to collect information about newsletter links that customers click on. This information is used to ensure that the information we send to our customers is exactly what they want to read. We collect this information cumulatively and it will never be linked to your personal information. ',
      info3:
        "Web beacons (also known as clear gif graphics techniques) or activity tags may be used on our sites to help deliver cookies. This technology lets us know how many visitors click on key elements (such as links or graphics) on the web pages of this website. We do not use this technology to obtain your personally identifiable information on this website; This is just a tool used to count the cumulative visit of this website's page. We may share site cumulative statistics with partner companies, but we do not allow other companies to place clear gif graphics on our site. ",

      info4:
        'If you choose not to allow your browser to receive cookies from this web site, you may browse the text on the screen, but you will not experience personalized  visits or subscribe to the services provided on the site.',
    },
    tip6: {
      title: 'Contact information',
      info1: 'You are welcome to comment on this Privacy Statement, please contact us by email.',
    },
    tip7: {
      title: 'About the website',
      info1:
        '1. The copyright of articles (including reposted articles) on this website shall belong only to the original author, and if the author has a copyright notice or the article is reproduced from another website with a copyright notice attached to the original site, the copyright attribution shall prevail according to the accompanying notice. ',
      info2:
        '2. This website shall be exempt from liability for the disclosure of personal data and any legal disputes and consequences arising from other websites linked to this website. ',
      info3:
        '3. When government judicial organs require this website to disclose personal data in accordance with legal procedures, we will provide personal data in accordance with the requirements of law enforcement units or for public safety purposes. In any disclosure in such circumstances, this website is exempt from liability.',
    },
    tip8: {
      title: 'About the Operation of this Website',
      info1:
        '1. During system maintenance or upgrade , service on this website will be suspended and that will be announced in advance. This website shall not be liable for any inconvenience or loss caused by the suspension of service due to hardware failure or other force majeure outside the control of the Company. ',
      info2:
        '2. This website shall be exempted from liability for the disclosure, loss, theft or alteration of personal data caused by computer year 2000 problems, hacking attacks, computer virus intrusions or attacks, temporary shutdowns caused by government controls, etc., which affect the normal operation of the network.',
    },
    tip9: {
      title: 'About Legal Liability',
      info1:
        "1. Due to violations of the provisions of this statement and violate the laws of the People's Republic of China, the users of this website will take the  consequences at their own responsibility/risk,  this website does not assume any responsibility.",
      info2:
        '2. Anyone who logs on to this website in any way or uses the materials of this website directly or indirectly shall be deemed to be subject to the restrictions stated on this website on a voluntary basis.',
      info3:
        '3. This statement does not cover the issues see the relevant laws and regulations of the country, when this statement and national laws and regulations conflict, the national laws and regulations shall prevail. ',
    },
    tip10: {
      title: 'On the right of interpretation',
      info1: 'The statements of this website and their right to modify, update and finally interpret are the property of this website.',
    },
 
  },
  footer: {
    title: 'Organizing Committee of China Coal & Mining Expo 2023',
    titleTop: 'Nineteenth session',
    titleBottom: 'Organizing Committee of China Coal & Mining Expo 2023',
    link: 'Quick Link',
    company: 'Together Expo Limited',
    weChatOfficialAccount: 'WeChat Official Account',
    qrCodeAttention: 'Please Scan the QR code to Follow Us ',
    mobileQrCodeAttention:'Please scan the QR code to follow the wechat official account of the exhibition',
    copyright: 'Copyright : China Coal Consultant International',
    technicalSupport: 'Technical Support：中煤信息技术(北京)有限公司',
    spareNumber1: '京公网安备11010102002548号',
    spareNumber2: '京ICP备09033595号-1',
    address: 'Zhongmei Building 605, Andingmenwai Street Yi 88, Dongcheng District, Beijing',
    linkUrl: {
      viewcz: 'I want to exhibit',
      viewcg: 'I want to Visit',
      zwt: 'Floor Plan',
      zhrc: 'Exhibition Schedule ',
      hzZhanhui: 'Official Website',
      mjlt: 'Forum',
    },
    unit: {
      title1: 'Host ',
      title2: 'Co-Host',
      title3: 'Organizers',
      text1: 'China National Coal Association',
      text2: 'China National Coal Group Corp',
      text3: 'China Coal Consultant International',
    },
  },
  //菜单栏
  navbar: {
    home: 'Home',
    PersonalInfo: 'Personal Information',
    basicInfo: 'Basic Information',
    letter: 'Confirmation Letter',
    questionnaire: 'Questionnaire',
    updataPassword: "Reset Password",
    publicize: 'Online Exhibition',

    collecytion: 'My Favorite',
    collExhibitors: 'Exhibitors',
    collProduct: 'Exhibits',
    collLive: 'Live Broadcast',
    collActive: 'Activities',
    MyMessage: "Message",
    
    logout:"Logout"
  },
  //
  mobile:{
    editRegisMessage:'If you need to modify the registration information, Please',
    clickHereL:'click here ',
    logBackManage:'Log in the background of China International Mining Exhibition Visitor Center.',
    clickLook:'Click to view',
    authentication:'Real-name through!',
    talk:'Talk',
    Favorites:'Favorites ',
    cancel:"cancel",
    sendImg:'Sending pictures',
    input:'Please input',
    send:'send',
    FavoritesPro:'Favorites',
},
Favorites:{
  collentExhibitors:'Favorites exhibitors',  //收藏展商
  collentExhibits:'Favorites Exhibits', //收藏展品
  collentLive:'Favorite live stream',
  collentActive:'Favorites Activity',
 }


}